import React from 'react';

import '../css/Header.scss';
import '../css/Flex.scss';

import ProfileImg from '../assets/profile_img.svg';

export default function Header() {
    const openProfile = () => {
        console.log('open profile');
    }
    const openWallet = () => {
        console.log('open wallet');
    }
    const goHome = () => {
        console.log('go home');
    }
    return (
        <header className='header flex-container space-between'>
            <h2 className='logo' onClick={goHome}>Aces</h2>
            <h2 className='title'>Poker Room</h2>
            <div className='header-right-container flex-container space-around'>
                <div className='wallet-status-container flex-container space-around' onClick={openWallet}>
                    <div className='status-indicator'></div>
                    <h3 className='status'>Wallet Connected</h3> {/*TODO: change this to dynamic*/}
                </div>
                <img className='profile' src={ProfileImg} onClick={openProfile} alt="white circle with a person's shape cutout"></img>
            </div>
        </header>
    )
}
